import React from "react";
import Icon from "@mdi/react";
import { mdiCheck } from "@mdi/js";

export default ({
  label,
  labelComponent,
  checked = false,
  setValue = () => {},
  ...modifiers
}) => {
  let className = "checkbox";
  className = Object.keys(modifiers).reduce(
    (acc, modifier) => `${acc} -${modifier}`,
    className
  );
  return (
    <label className={className}>
      <input
        className="checkbox_input"
        type="checkbox"
        checked={checked}
        onChange={e => setValue(!checked)}
      />
      <span className="checkbox_checkmark">
        {checked && <Icon path={mdiCheck} color="white" size={"16px"} />}
      </span>
      {!labelComponent && <span className="checkbox_label">{label}</span>}
      {labelComponent}
    </label>
  );
};
